import type {ReactElement} from 'react';
import React from 'react';
import type {IconWithTooltipProps} from './icon-with-tooltip.types';
import styles from './icon-with-tooltip.module.scss';
import {Icon} from '@Components/icon-v2';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {TOOLTIP_POSITION} from '@Components/tooltip';
import {getClassesForPosition} from '@Components/tooltip/tooltip-helper';

export function IconWithTooltip({arrowPosition = TOOLTIP_POSITION.BOTTOM_MIDDLE, ...props}: IconWithTooltipProps): ReactElement<any> {

  const getClassesForArrowPosition = (): string => {
    return getClassesForPosition(arrowPosition)
  }
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      overlay={<Tooltip className={`spacing-m-b-1 _rounded-arrow ${getClassesForArrowPosition()} ${styles.tooltip}`}>{props.tooltipText}</Tooltip>}
      delay={{show: 0, hide: props.toolTipHideDelay ?? 0}}
      placement="top"
      offset={props.offset ? [props.offset.x, props.offset.y] : undefined}
    >
      <Icon {...props} className={props.className} />
    </OverlayTrigger>
  );
}
